import { render, staticRenderFns } from "./DeliveryProfileZone.vue?vue&type=template&id=3b53692e&"
import script from "./DeliveryProfileZone.vue?vue&type=script&lang=ts&"
export * from "./DeliveryProfileZone.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryProfileZone.vue?vue&type=style&index=0&id=3b53692e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports